import styled, { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 8px;
  font-family: 'IntervalNextReg', sans-serif;
  opacity: ${props => (props.animate ? 0 : 1)};
  flex-direction: column;
  align-items: end;
  padding: ${props => props.theme.space(3)} ${props => (props.isMobile ? props.theme.space(3) : props.theme.space(6))};
  ${({ theme }) => theme.gap(2, 'column')}

  ${props =>
    props.type === 'compact' &&
    css`
      background: ${props => props.theme.unisystem.statusBanner.background[props.color]};
    `}

  ${props =>
    props.type === 'text' &&
    css`
      background: transparent;
      padding-left: 0;
      padding-right: 0;
    `}

  ${props =>
    props.animate &&
    css`
      animation: ${fadeIn} 0.5s ease-in-out 0.4s forwards;
    `}

  ${props =>
    props.isFixed &&
    css`
      z-index: 2;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;

      ${props =>
        props.isMobile &&
        `
        position: absolute;
        bottom: 70px;
        left: 12px;
        right: 12px;
        width: calc(100% - 24px);
        margin-top: 0;
        margin-bottom: 0;
      `}
    `};

  svg {
    flex: 0 0 24px;
  }
`;

export const Text = styled.p`
  flex: 1;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(20)};
  width: 100%;

  color: ${props =>
    props.type === 'text' && props.color
      ? props.theme.unisystem.statusBanner.text[props.color]
      : props.theme.unisystem.statusBanner.text.default};

  ${props =>
    props.type === 'text' &&
    css`
      font-weight: 600;
    `}

  span {
    font-weight: 600;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  ${({ theme }) => theme.gap(3)}

  > button {
    width: auto;

    &:first-of-type {
      &:hover {
        background: transparent;
        text-decoration: underline;
      }
    }
  }
`;

export const MessageBanner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  > svg {
    margin-right: ${({ theme, type }) => (type === 'compact' ? theme.space(3) : theme.space(1))};
  }

  > * {
    margin: auto;
  }
`;

export const Close = styled.div`
  margin-left: ${props => props.theme.space(2)};
  cursor: pointer;

  svg {
    flex: 0 0 24px;

    path {
      fill: ${props => props.theme.unisystem.statusBanner.close.icon};
    }
  }
`;
